import { SVSummaryCardItem } from '@/types/common';
import { SVSummaryCard } from '../core';
import { TransactionReviewDetails } from '@/types/transactionReview';
import { titleCase } from '@/utils/stringCaser';
import { formatDateTimeFromUTC } from '@/utils/date';
import { Typography } from '@mui/material';

type TransactionReviewDetailsSummaryProps = {
  transactionReviewDetails: TransactionReviewDetails;
};

export default function TransactionReviewDetailsSummary({
  transactionReviewDetails,
}: TransactionReviewDetailsSummaryProps) {
  const {
    reviewStatus,
    reviewReasons,
    requestedBy,
    lastModifiedAt,
    lastModifiedBy,
    approvedBy,
    canceledBy,
    declinedBy,
  } = transactionReviewDetails.reviewSummary;
  const { requestedAt } = transactionReviewDetails.transactionDetails;

  const items: SVSummaryCardItem[] = [
    {
      label: 'Status',
      customContent: (
        <Typography
          sx={{
            fontWeight: 'bold',
            color:
              reviewStatus === 'approved'
                ? 'success.main'
                : reviewStatus === 'under review'
                  ? 'grey'
                  : 'error.main',
          }}>
          {titleCase(reviewStatus)}
        </Typography>
      ),
    },
    {
      label: 'Review Reason',
      text: titleCase(reviewReasons.join(', ')),
    },
    {
      label: 'Created By',
      text: `${requestedBy.userName} (${requestedBy.userEmail})`,
    },
    {
      label: 'Created Date',
      text: formatDateTimeFromUTC(requestedAt, true),
    },
    {
      label: 'Last Modified By',
      text: lastModifiedBy
        ? `${lastModifiedBy.userName} (${lastModifiedBy.userEmail})`
        : '',
    },
    {
      label: 'Approved By',
      text: approvedBy
        ? `${approvedBy.userName} (${approvedBy.userEmail})`
        : '',
    },
    {
      label: 'Declined By',
      text: declinedBy
        ? `${declinedBy.userName} (${declinedBy.userEmail})`
        : '',
    },
    {
      label: 'Canceled By',
      text: canceledBy
        ? `${canceledBy.userName} (${canceledBy.userEmail})`
        : '',
    },
    {
      label: 'Last Modified Date',
      text: lastModifiedAt ? formatDateTimeFromUTC(lastModifiedAt, true) : '',
    },
  ];

  return <SVSummaryCard label="Review Summary" items={items} />;
}
